import cx from 'classnames';
import {useSelector} from 'react-redux';
import {selectTextAreaOpen} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';
import {isSent, shouldUseNamedStepsNav} from '~/common/utils/event_utils';
import {usePremiumFeatureBlocker} from '~/OneStepCreateInvitation/hooks/usePremiumFeatureBlocker';
import {Button} from '~library/atoms/Button';
import {ArrowIcon} from '~library/svg/ArrowIcon';

import './NavBottom.sass';

export const NavBottom = ({
  ctas,
  hideContinueButton,
  onClickBack,
  className,
  firstChild,
  grayedOut,
  innerRef,
  centered = false,
}) => {
  const {isUsingPremiumFeature, onBlockedElementClick} = usePremiumFeatureBlocker();
  const textAreaOpen = useSelector(selectTextAreaOpen);
  const eventStatus = useSelector(({eventDetails}) => eventDetails.status);
  const isEventSent = isSent(eventStatus);
  const useNamedStepsNav = shouldUseNamedStepsNav();

  return (
    <div className={cx(className, 'card-design__nav-bottom')} ref={innerRef}>
      {firstChild}
      {!hideContinueButton &&
        !textAreaOpen &&
        (!useNamedStepsNav || (useNamedStepsNav && isEventSent)) && (
          // biome-ignore lint/a11y/useKeyWithClickEvents: TODO: Use only one <Button> & onClick
          // biome-ignore lint/a11y/noStaticElementInteractions: see above
          <div
            className={cx({
              'card-design__nav-bottom__cta_wrapper': true,
              'card-design__nav-bottom__cta_wrapper--centered': centered,
              'grayed-out': grayedOut,
            })}
            role={isUsingPremiumFeature ? 'button' : 'generic'}
            tabIndex={isUsingPremiumFeature ? 0 : -1}
            onClick={isUsingPremiumFeature ? onBlockedElementClick : null}
          >
            {onClickBack && (
              <Button
                className="nav-bottom__back-button"
                data-qa-id="nav-bottom-previous"
                variant="secondary"
                size="large"
                type="button"
                ariaLabel="Back"
                onClick={onClickBack}
              >
                <ArrowIcon direction="left" ratio={0.75} />
              </Button>
            )}
            {ctas && <div className="card-design__nav-bottom__ctas">{ctas}</div>}
          </div>
        )}
    </div>
  );
};
